import {
	InterventionListDto,
	PublicHealthInterventionStatus as Status,
} from 'services/src/models';

export const getInterventionActionAvailability = (
	record: InterventionListDto,
	userSubjectId: string | undefined,
	canModify: boolean,
	hasPermission: boolean
) => {
	const owns =
		userSubjectId !== undefined &&
		(record.subjectId === userSubjectId ||
			!!record.coowners?.includes(userSubjectId));
	const clone =
		hasPermission &&
		owns &&
		!record.patternStatus &&
		record.status !== Status.CANCELED;
	const suspend =
		clone &&
		![
			Status.ARCHIVED,
			Status.COMPLETEDREALIZED,
			Status.COMPLETEDUNREALIZED,
			Status.FROZEN,
		].includes(record.status!);
	const cancel = suspend && record.status === Status.PLANNED;
	return {
		edit: hasPermission && canModify && !record.patternStatus,
		clone,
		suspend,
		cancel,
		more: suspend || cancel,
	};
};
